/**
 * Card Component
 *
 * Generic card with icon, title, description, and collapsible body.
 * Used throughout the admin panel for grouping related content.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a card with icon, title, and optional collapsible body.
 *
 * @param {string} icon - Emoji or icon character
 * @param {string} title - Card title
 * @param {string} description - Card description
 * @param {Array} children - Child elements for card body
 * @param {Object} options - { collapsible, collapsed, warning, staggerIndex }
 */
export function Card(icon, title, description, children, options = {}) {
    const { collapsible = false, collapsed = false, warning = false, staggerIndex = 0 } = options;

    let cardClass = 'presszone-comments-settings-card';
    if (collapsible) cardClass += ' presszone-comments-settings-card--collapsible';
    if (collapsed) cardClass += ' presszone-comments-settings-card--collapsed';
    if (warning) cardClass += ' presszone-comments-settings-card--warning';
    cardClass += ` presszone-comments-stagger-${Math.min(staggerIndex, 10)}`;

    const header = el('div', {
        class: 'presszone-comments-settings-card__header',
        onclick: collapsible ? (e) => {
            const card = e.currentTarget.parentElement;
            card.classList.toggle('presszone-comments-settings-card--collapsed');
        } : null
    },
        el('div', { class: 'presszone-comments-settings-card__icon' }, icon),
        el('div', {},
            el('h3', { class: 'presszone-comments-settings-card__title' }, title),
            description ? el('p', { class: 'presszone-comments-settings-card__desc' }, description) : null
        )
    );

    const validChildren = (children || []).filter(child => child != null);

    return el('div', {
        class: cardClass
    },
        header,
        el('div', { class: 'presszone-comments-settings-card__body' }, ...validChildren)
    );
}

export default Card;
